import { Button } from "antd";
import React, { useEffect, useState } from "react";
import { FaDownload } from "react-icons/fa";
import { Outlet, useLocation, useOutletContext } from "react-router-dom";

import searchicon from "../Assests/Images/search.png";
import crossimg from "../Assests/Images/wrong.png";
import CommonButton from "../Components/Buttons/CommonButton";
import { CheckUserType } from "../Shared/Methods";
import { useSelector } from "react-redux";
import { FaCloudDownloadAlt } from "react-icons/fa";
import BackedUpDataModal from "../Modals/BackedUpDataModal";

function ReportsLayout() {
  const location = useLocation();
  const { pathname } = location;
  const outletcontext: any = useOutletContext();
  const { dashboardData } = outletcontext;
  const PinList = dashboardData?.pin_list || [];

  const [isDownload, setIsDownload] = useState<boolean>(false);
  const [showfilter, setShowFilter] = useState<boolean>(false);
  const { IsReportsDownload } = useSelector((state: any) => state.Dashboard);

  const [BackedupModal, setBackedupModal] = useState<any>({
    show: false,
    id: 0
  });
  useEffect(() => {
    if (
      pathname !== "/reports/readingreport" &&
      pathname !== "/reports/notificationreport"
    ) {
      setShowFilter(false);
    }
  }, [pathname]);

  const getItems = () => {
    if (pathname === "/reports/readingreport") {
      return {
        heading: "Reading Report",
        reportId: 1
      };
    } else if (pathname === "/reports/consumptionreport") {
      return {
        heading: "Consumption Report",
        reportId: 2
      };
    } else if (pathname === "/reports/historyreport") {
      return {
        heading: "History Report",
        reportId: 3
      };
    } else if (pathname === "/reports/notificationreport") {
      return {
        heading: "Notification Report",
        reportId: 4
      };
    } else if (pathname === "/reports/failureanalysisreports") {
      return {
        heading: "Failure Analysis",
        reportId: 6
      };
    } else if (pathname === "/reports/alertreport") {
      return {
        heading: "Alert Report",
        reportId: 5
      };
    }
  };

  return (
    <>
      {BackedupModal.show && (
        <BackedUpDataModal
          reportId={getItems()?.reportId}
          open={BackedupModal.show}
          headerName={getItems()?.heading}
          closable={!BackedupModal.show}
          onCancel={() => {
            setBackedupModal({ show: false });
          }}
        />
      )}

      <div className="header_container">
        <h3>{getItems()?.heading}</h3>
        <div className="d-flex align-items-end gap-2">
          {/* {pathname !== "/reports/failureanalysisreports" && (
            <Button
              className="me-3 downloadbg"
              type="primary"
              icon={<FaDownload />}
              size={"large"}
              onClick={() => {
                setIsDownload(true);
              }}
            >
              Download
            </Button>
          )} */}

          <div className="search_bg">
            {!showfilter ? (
              <img
                src={searchicon}
                className="search_icon"
                onClick={() => setShowFilter(true)}
                alt="searchicon"
              />
            ) : (
              <img
                src={crossimg}
                className="search_icon"
                onClick={() => setShowFilter(false)}
                alt="crossimg"
              />
            )}
          </div>
          {pathname !== "/reports/failureanalysisreports" && (
            <CommonButton
              type="button"
              name="Backedup Data"
              onClick={() => {
                setBackedupModal({
                  show: true,
                  report_id: getItems()?.reportId
                });
              }}
              icon={<FaCloudDownloadAlt style={{ fontSize: "15px" }} />}
              classname="backedup_btn"
            />
          )}

          {pathname !== "/reports/failureanalysisreports" &&
          CheckUserType() &&
          IsReportsDownload ? (
            <CommonButton
              type="button"
              name="Download"
              onClick={() => {
                setIsDownload(true);
              }}
              icon={<FaDownload />}
              classname="download_btn"
            />
          ) : null}
        </div>
      </div>
      <Outlet
        context={{
          showfilter: showfilter,
          isDownload: isDownload,
          setIsDownload: setIsDownload,
          setShowFilter: setShowFilter,
          PinList: PinList
        }}
      />
    </>
  );
}

export default ReportsLayout;
